export default (form, listLicencePlate) => {
  const startDate = CreateDate(form.date, form.startTime)
  const endDate = CreateDate(form.date, form.endTime)

  const countFor200 = generateRegisterFor200({
    startDate,
    endDate,
    count200: form.count200,
    listLicencePlate
  })
  const countFor250 = generateRegisterFor250({
    startDate,
    endDate,
    count250: form.count250,
    listLicencePlate
  })
  const countFor500 = generateRegisterFor500({
    startDate,
    endDate,
    count500: form.count500,
    listLicencePlate
  })

  return {
    countFor200,
    countFor250,
    countFor500
  }
}

const CreateDate = (date, startTime) => {
  const dateString = `${date} ${startTime}`
  return new Date(dateString)
}

const pickRandomLicencePlate = (listLicencePlate) => {
  const r = Math.ceil(Math.random() * listLicencePlate.length - 1)
  return listLicencePlate[r]
}

const generateRegisterFor200 = ({ startDate, endDate, count200, listLicencePlate }) => {
  let count200Register = []
  const timeRatio = (endDate.getTime() - startDate.getTime()) / count200

  for (let reg = 0; reg < count200; reg++) {
    const nextForceTime = (startDate.getTime() + (reg * timeRatio)) + GenerateRandom(timeRatio)
    const licencePlate = pickRandomLicencePlate(listLicencePlate)

    const payload = {
      licencePlate: licencePlate.licencePlate,
      userId: null,
      forceTime: new Date(nextForceTime),
      creditPaid: {
        licencePlate: licencePlate.licencePlate,
        amountPaid: 200,
        totalMinutes: 60
      },
      parkingPlace: {
        parking: null,
        licencePlate: licencePlate.licencePlate
      }
    }
    count200Register.push(payload)
  }

  return count200Register
}

const generateRegisterFor250 = ({ startDate, endDate, count250, listLicencePlate }) => {
  let count250Register = []
  const timeRange = (endDate.getTime() - startDate.getTime())

  for (let reg = 1; reg <= count250; reg++) {
    const randomTime = Math.ceil(Math.random() * timeRange) + 1000
    const newTime = startDate.getTime() + randomTime
    const licencePlate = pickRandomLicencePlate(listLicencePlate)

    count250Register.push({
      licencePlate: licencePlate.licencePlate,
      userId: null,
      forceTime: new Date(newTime),
      creditPaid: {
        licencePlate: licencePlate.licencePlate,
        amountPaid: 250,
        totalMinutes: 60
      },
      parkingPlace: {
        parking: null,
        licencePlate: licencePlate.licencePlate
      }
    })
  }

  return count250Register
}

const generateRegisterFor500 = ({ startDate, endDate, count500, listLicencePlate }) => {
  let count500Register = []
  const timeRange = (endDate.getTime() - startDate.getTime())

  for (let reg = 1; reg <= count500; reg++) {
    const randomTime = Math.ceil(Math.random() * timeRange) + 1000
    const newTime = startDate.getTime() + randomTime
    const licencePlate = pickRandomLicencePlate(listLicencePlate)

    count500Register.push({
      licencePlate: licencePlate.licencePlate,
      userId: null,
      forceTime: new Date(newTime),
      creditPaid: {
        licencePlate: licencePlate.licencePlate,
        amountPaid: 500,
        totalMinutes: 60
      },
      parkingPlace: {
        parking: null,
        licencePlate: licencePlate.licencePlate
      }
    })
  }

  return count500Register
}

const GenerateRandom = (timeRatio) => Math.ceil((Math.random() * timeRatio) + 1000)
